// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"337":"c1a82b63","377":"e462debd","600":"e44aaa22","816":"4a89f83b","913":"3616a146"}[chunkId] + ".chunk.js";
};